<template>
    <div class="article">
        <ul class="has-data">
            <li :class="`data-item data-item${item.id}`" v-for="(item,index) in articleList" :key="index">
                <articleContainer
                    :userId="userId"
                    :articleInfo="item"
                    @tagSelector="tagSelector"
                    @onVoteToggle="onVoteToggle"
                    @favoriteToggle="favoriteToggle">
                </articleContainer>
            </li>
        </ul>
        <div  class="load-more" v-show="questionList.length">
            <img v-if="isLoading" alt="loadding" src="../../images/common/loading_2_24x24.gif">
            <p class="no-more" v-else-if="Math.ceil(articleList.length / 10) === listCount">没有更多文章了</p>
            <p v-else @click="doLoadMore()">加载更多</p>
        </div>
        <v-alert :options="options"></v-alert>
    </div>
</template>

<script>
import bus from '@/js/bus.js'
import vAlert from '../alert.vue';
import articleContainer from './articleContainer.vue'

export default {
    props: {
        questionList: {
            type: Array,
            default: () => []
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            default: 0
        },
        listCount: {
            type: Number,
            default: 0
        }
    },
    components: {
        'v-alert': vAlert,
        articleContainer
    },
    data () {
        return {
            options: { // 消息弹窗
                msgText: '',
                msgIsSuccess: true
            },
            articleList: [],
            expandedComments: [], // 评论展开id列表
            fixedCommentId: '' // 当定固定的评论id

        }
    },
    watch: {
        questionList: {
            handler (val) {
                this.articleList = val
                this.articleList.forEach(item => {
                    if (item.comment) {
                        item.newestComment = this.getControlLength(item.comment, item.show_image.length)
                        this.$set(item, 'isShowAllComment', item.newestComment.slice(-4) !== ' ...')
                    }
                })
            },
            immediate: true
        }
    },
    methods: {
        // 点击热门标签
        tagSelector (item) {
            this.$emit('onSelectCommentTag', item.title);
        },
        getControlLength (val, img) {
            val = val.replace(/[\r\n]/g, '').replace(/\s/g, '');
            if (val.length > 80 && img === 0) {
                val = val.substring(0, 80) + ' ...';
            } else if (val.length > 40 && img !== 0) {
                val = val.substring(0, 40) + ' ...';
            }
            return val;
        },
        // 点赞&取消点赞
        onVoteToggle (val) {
            try {
                if (!this.isLogin) {
                    this.onLogin()
                    return
                }
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup')
                    return
                }
                let params = {
                    topic_id: val.id,
                    vote: val.is_vote_up ? null : true
                }
                axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                    if (res.data.result) {
                        val.is_vote_up = val.is_vote_up ? null : true;
                        let msg = ''
                        if (val.is_vote_up) {
                            val.no_of_vote_up += 1;
                            msg = '点赞成功'
                        } else {
                            val.no_of_vote_up -= 1;
                            msg = '取消点赞成功'
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error);
            }
        },
        // 收藏&取消收藏
        favoriteToggle (item) {
            if (!this.isLogin) {
                this.onLogin()
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup')
                return
            }
            let params = {
                topic_id: item.id,
                is_like: !item.is_liked
            };
            axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                if (res.data.result) {
                    item.is_liked = !item.is_liked;
                    let msg = ''
                    if (item.is_liked) {
                        item.no_of_likes += 1;
                        msg = '收藏成功'
                    } else {
                        item.no_of_likes -= 1;
                        msg = '取消收藏成功'
                    }
                    this.$message({
                        message: msg,
                        type: 'success'
                    })
                }
            })
        },
        // 加载更多
        doLoadMore () {
            this.$emit('doLoadMore', true)
        },
        // 去登录
        onLogin () {
            axios.get(myUrl + 'login/test/')
        }
    }
}
</script>

<style lang="scss" scoped>
    .article {
        .has-data {
            .data-item {
                padding: 21px 24px 17px;
                border-bottom: 1px solid #f0f1f5;
                &:first-child {
                    padding-top: 10px;
                }
                &:last-child {
                    border-bottom: none;
                }
            }
        }
        .load-more {
            margin-top: 10px;
            width: 100%;
            height: 42px;
            line-height: 42px;
            color: #828282;
            font-size: 14px;
            background: #fff;
            cursor: pointer;
            outline: none;
            text-align: center;
            .no-more {
                font-size: 12px;
                cursor: default;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// article.vue?81f3f798